import { dollarToString } from "../../lib/currency-utils";

export const isEmptyObj = (obj) => {
    return Object.keys(obj).length === 0;
}

export const undoToLocaleString = (formattedString) => {
    if(typeof formattedString !== 'string') return;
    
    const regex = /[$,.]/g

    const normalizedString = formattedString.replace(regex, '');

    if(normalizedString === '') return '';

    // Parse back to number
    return parseFloat(normalizedString);
} 

export const undoToLocaleStringWithDecimal = (formattedString) => {
    if(typeof formattedString !== 'string') return;

    const regex = /[$,]/g

    const normalizedString = formattedString.replace(regex, '');

    if(normalizedString === '') return '';

    return parseFloat(normalizedString);
}

export const cleanMonetaryInputValue = (text) => {
    let value = text;
    value = undoToLocaleString(value);

    if(!value) {
        return 0;
    }

    return value;
}

export const formatMonetaryInputValues = (text, isCalculateNoCents) => {
    let value = text;
    value = undoToLocaleString(value);

    if(!value) {
        return value;
    }

    return dollarToString(value, isCalculateNoCents);
}

export const isValidDecimalInput = (text) => {
    let value = text;
    // const regex = /^\d*\.?\d*$/
    const regex = /^\d*\.?\d{0,2}$/
    const isValid = regex.test(value);

    if (!isValid) {
        return false;
    }

    return true;
}

export const formatMonetaryDecimalInputValues = (text) => {
    let value = text;
    value = undoToLocaleStringWithDecimal(value);

    if(!value) {
        return value;
    }

    return value;
}

export const roundNumber = (value, decimalPlace = 0) => {
    const shifter = Math.pow(10, decimalPlace);
    return (Math.round(value * shifter) / shifter);
}

export const convertEpochTimeToDate = (epochTime) => {
    const date = new Date(epochTime);
    const mm = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const dd = String(date.getDate()).padStart(2, "0");
    const yy = String(date.getFullYear()).slice(-2); // Get last two digits of the year

    return `${mm}/${dd}/${yy}`;
}

export const formatToDash = (date) => {
    const [ year, month, day ] = date.split('/');
    return `${year}-${month}-${day}`;
}

export const addYearsToDate = (dateString, yearsToAdd) => {
    // Parse the date string (assumes format yyyy/mm/dd)
    let [ year, month, day ] = dateString.split('-').map(Number);

    // Add the years
    year += yearsToAdd;

    // Format back to yyyy/mm/dd
    return `${year}/${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}`;
}

export const getYearsFromStartDate = (startDate, currentDate) => {
    const [ startDateYear ] = startDate.split('-').map(Number);
    const [ currentDateYear ] = currentDate.split('-').map(Number);

    return currentDateYear - startDateYear;
}

export const getMaturityYears = (endDate, currentDate) => {
    const [ endDateYear ] = endDate.split('-').map(Number);
    const [ currentDateYear ] = currentDate.split('-').map(Number);

    return endDateYear - currentDateYear;
}

